import PropTypes from 'prop-types'
import { useState } from 'react'
import MsjBrowser from 'components/MsjBrowser'
import { useTheme } from 'styled-components'

import { StyledButtonContainer, StyledButton, StyledButtonOutlined, StyledLoader, StyledTextBefore, StyledTextAfter, StyledButtonIcon, StyledImageButton } from './styles'
import ReactHtmlParser from 'react-html-parser'

const Uploadbutton = ({ children, dataGa, disabled, id, href, msjBrowser, outline, target, flat, beforeText, afterText, part }) => {

  const [isBrowserOpen, setIsBrowserOpen] = useState(false)
  const loading = false;

  const theme = useTheme();

  const getStyle = () => {
    if (theme && theme.button_outlined_as_default) {
      return outline ? StyledButton : StyledButtonOutlined
    }
    return outline ? StyledButtonOutlined : StyledButton
  }

  const ButtonStyle = getStyle()

  return (
    <>
      <StyledButtonContainer $columns={getStyle('nbrPerCol', part)}>
        {beforeText && <StyledTextBefore>{beforeText}</StyledTextBefore>}
        {!!msjBrowser ? (
          <ButtonStyle
            id={id}
            data-dataga={dataGa || 'link button'}
            className={disabled ? 'disabled' : ''}
            onClick={(e) => {
              e.preventDefault()
              setIsBrowserOpen(!isBrowserOpen)
            }}
            $flat={flat || false}
          >
            <label>{children}</label>
          </ButtonStyle>
        ) : part.useImage ? (
          <>
            <StyledImageButton
              as={'button'}
              $borderWidth={part.style.borderWidth || '3'}
              $borderRadius={part.style.borderRadius || '50'}
              $nbrPerCol={part.style.nbrPerCol || '2'}
              onClick={(e) => {
                e.preventDefault()
                setIsBrowserOpen(!isBrowserOpen)
              }}
              id="download with picture button"
              data-ga="link button-round image"
              style={
                part.buttonImageUrl &&
                part.buttonImageUrl.length > 0 && { backgroundImage: `url("${part.buttonImageUrl}")` }
              }
            ></StyledImageButton>
            <span>{ReactHtmlParser(part.text)}</span>
          </>
        ) : (
          <ButtonStyle
            id={id}
            href={href}
            target={target}
            data-dataga={dataGa || 'link button'}
            className={loading || disabled ? 'disabled' : ''}
            onClick={(e) => {
              e.preventDefault()
              setIsBrowserOpen(!isBrowserOpen)
            }}
            $flat={flat || false}
          >
            {loading && <StyledLoader />}

            <label>
              {part.icon === 'IconOne' && (
                <StyledButtonIcon viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
                  <path d="m544.45 142.4c-36.562 0-66.656 30.094-66.656 66.656v179.29c0 12.516-9.7031 22.219-22.219 22.219l-102 0.046876c-17.109 0-31.688 11.25-37.312 25.125s-3.0469 32.109 9.1875 44.062l227.26 221.39c26.156 25.5 68.531 25.5 94.688 0l227.21-221.39c12.281-11.953 14.859-30.188 9.2344-44.062-5.6719-13.875-20.25-25.125-37.359-25.125h-102.05c-12.516 0-22.219-9.7031-22.219-22.219v-179.29c0-36.562-30.094-66.656-66.656-66.656zm0 44.438h111.09c12.516 0 22.219 9.7031 22.219 22.219v179.29c0 36.562 30.094 66.656 66.656 66.656l91.875 0.046876-219.94 214.31c-9.2344 9-23.391 9-32.625 0l-219.98-214.31h91.781c36.562 0 66.656-30.094 66.656-66.656l0.046875-179.29c0-12.516 9.7031-22.219 22.219-22.219zm-344.44 548.48c-36.562 0-66.656 30.094-66.656 66.656v188.9c0 36.562 30.094 66.656 66.656 66.656h800.02c36.562 0 66.656-30.094 66.656-66.656v-188.86c0-36.562-30.094-66.656-66.656-66.656h-155.58c-36 0-68.203 23.203-79.594 57.375l-16.312 48.984c-5.3906 16.172-20.344 26.953-37.406 26.953h-222.24c-17.062 0-32.016-10.781-37.406-26.953l-16.359-48.984c-11.391-34.172-43.547-57.422-79.594-57.422zm0 44.438h155.58c17.062 0 32.016 10.828 37.406 27l16.266 49.031c11.391 34.172 43.594 57.328 79.594 57.328h222.24c36 0 68.203-23.156 79.594-57.328l16.359-48.984c5.3906-16.172 20.344-27 37.406-27h155.58c12.516 0 22.219 9.7031 22.219 22.219v188.9c0 12.516-9.7031 22.219-22.219 22.219l-800.02-0.046876c-12.516 0-22.219-9.7031-22.219-22.219v-188.86c0-12.516 9.7031-22.219 22.219-22.219z" />
                </StyledButtonIcon>
              )}

              {part.icon === 'IconTwo' && (
                <StyledButtonIcon viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="m1169.6 946.78v171.28c0.14062 28.688-23.297 52.078-51.938 51.938h-1035.4c-28.688 0.14062-52.078-23.297-51.938-51.938v-171.28c0-8.2969 2.5312-15.844 6-22.781l103.31-207.14c8.7656-17.625 26.766-28.688 46.312-28.688h155.16c70.688-1.5469 70.688 105.14 0 103.55l-123.1 0.046874-51.844 103.55h867.84l-51.703-103.55h-123.52c-67.453 1.6875-72.375-98.766-4.9219-103.55h160.22c19.547 0.14062 37.453 11.156 46.219 28.688l103.31 207.14c3.4688 6.8906 5.8594 14.484 5.9531 22.734z"
                    fill-rule="evenodd"
                  />
                  <path
                    d="m843.61 497.29-207 207.24c-20.297 20.062-52.781 20.062-73.078 0l-207.14-207.24c-8.7656-8.5312-14.297-19.781-15.469-32.062-2.8594-28.453 18-53.766 46.453-56.625 15.703-1.5469 31.453 4.2188 42.469 15.703l118.31 118.45v-459.98c-0.46875-28.781 22.547-52.453 51.234-52.781 29.297-0.375 52.922 23.625 52.453 52.781v460.45l118.78-118.92c1.6875-2.0625 3.6094-3.9375 5.625-5.625 21.703-18.609 54.375-16.078 72.938 5.625 18.656 21.75 16.125 54.375-5.5781 72.984z"
                    fill-rule="evenodd"
                  />
                </StyledButtonIcon>
              )}
              {part.icon === 'IconThree' && (
                <StyledButtonIcon viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
                  <path d="m541.41 1032.3c32.227 37.559 84.961 37.559 117.19 0l281.88-328.61c32.227-37.578 18.105-68.281-31.387-68.281h-127.23v-416.88h-363.69v416.88h-127.25c-49.492 0-63.613 30.703-31.387 68.281z" />
                  <path d="m418.16 29.16h363.69v125.62h-363.69z" />
                  <path d="m129.45 1101.7h941.09v69.16h-941.09z" />
                </StyledButtonIcon>
              )}
              {children}
            </label>
          </ButtonStyle>
        )}
        {afterText && <StyledTextAfter>{afterText}</StyledTextAfter>}

        <MsjBrowser isOpen={isBrowserOpen} onClose={() => setIsBrowserOpen(false)} src={href} uploadButton />
      </StyledButtonContainer>
    </>
  )
}

Uploadbutton.propTypes = {
  backBtn: PropTypes.bool,
  children: PropTypes.node,
  dataGa: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  href: PropTypes.string,
  msjBrowser: PropTypes.bool,
  outline: PropTypes.bool,
  target: PropTypes.string,
  variant: PropTypes.string,
  flat: PropTypes.bool,
  beforeText: PropTypes.string,
  afterText: PropTypes.string,
}

export default Uploadbutton
